import { Box, Button } from 'grommet';

export const ActionButtons = (): JSX.Element => {
  return (
    <Box
      direction="row"
      gap="small"
      margin={{ top: 'medium' }}
    >
      <Button
        type="submit"
        label="Submit"
        primary
      />

      <Button
        type="reset"
        label="Clear form"
      />
    </Box>
  );
};
